module.exports = __webpack_public_path__ + "media/bootstrap-icons/chat-right-quote-fill-383e3246.svg";